import {BrowserModule, Title} from "@angular/platform-browser";
import {CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA,} from "@angular/core";
import {AppRoutingModule} from "./app.routing.module";
import {AppComponent} from "./app.component";
// Shared Modules
import {CommonModule} from "@angular/common";
import {SharedModule} from "./shared/shared.module";
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {provideHttpClient} from "@angular/common/http";

@NgModule({
    declarations: [AppComponent],
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        SharedModule,
        AppRoutingModule,
    ],
    exports: [],
    providers: [provideHttpClient(), Title],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AppModule {
}
